module.exports = __webpack_public_path__ + "img/member-none.841e7909.svg";